/*
 * COPYRIGHT 2022-2024 YOSPACE TECHNOLOGIES LTD. ALL RIGHTS RESERVED.
 * The contents of this file are proprietary and confidential.
 * Unauthorised copying of this file, via any medium is strictly prohibited.
 *
 */

// These URLs are static for example purposes until we have a backend that handles accounts
export const YOSPACE_EVENT_STREAM_MANAGER_API_URL = "https://lefort-poc-euw1-001-external.syseng.yospace.com/orchestrator/v1/events";
export const YOSPACE_GRAFANA_URL = "https://cg-poc-use1-001.syseng.yospace.com/d/WX892OYnz/live-concurrency?orgId=1&var-content_provider=CONTENT_PROVIDER&var-external_id=EXTERNAL_ID&var-feed_id=FEED_ID";
export const YOSPACE_EVENT_STREAM_STATUS_URL = "https://lefort-poc-euw1-001-external.syseng.yospace.com/orchestrator/v1/status";
